<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"560px"'

    :cpntOnFecharDialog='onFecharFormulario'>
    <template slot='titulo'>
      <template v-if='(registro.length === 1 && registro[0] === 0)'>
        <i aria-hidden="true" class="fa fa-angle-double-right"></i>
        Nova Situação Fiscal de Serviço
      </template>
      <template v-else-if='(registro.length === 1 && registro[0] >= 1)'>
        <i aria-hidden="true" class="fa fa-angle-double-right"></i>
        Edição da Situação Fiscal de Serviço {{ registro[0] }}
      </template>
      <template v-else>
        <i aria-hidden="true" class="fa fa-angle-double-right"></i>
        <span style='color: red;'>{{ registro }}erro ao identificar registro</span>
      </template>          

      <RF-Codigo-RF class="servico-sit-fiscal-codigoRF" v-if='formulario1.hasOwnProperty("codigoRF") && Object.keys(formulario1.codigoRF).length >= 1' style='margin-top: 20px; margin-left: 15px; margin-bottom: 0px;'
        :class='"class-time-" + time + " rf-field-tamanho-" + (formulario1.codigoRF.hasOwnProperty("tamanho") ? formulario1.codigoRF.tamanho : 0)'
        :cpntStatus='formulario1.codigoRF.status'
        :cpntId='formulario1.codigoRF.id'
        :cpntRouter='formulario1.codigoRF.router'
        :cpntMethod='formulario1.codigoRF.method'
      ></RF-Codigo-RF>
    </template>

    <template slot='conteudo'>
      <div v-if='Object.keys(formulario1).length >= 1' style="padding-top: 20px;">
        <RF-Formulario :data-time='time'
          :cpntTime='time'
          :cpntId='formulario1.id' 
          :cpntStatus='""'
          :cpntField='formulario1.field'

          @onLimpaFormularioFocus='formulario1.focus = ""'
          :ref='formulario1.id'
        ></RF-Formulario>

        <RF-Tabela :data-time='time' v-if='Object.keys(tabelaImpostos).length >= 1 && tabelaImpostos.mostrar === true'
          :cpntTime='time'
          :cpntId='tabelaImpostos.id'
          :cpntStatus='tabelaImpostos.status'
          :cpntButtonImprimir='tabelaImpostos.acoes.btImprimir'
          :cpntButtonAtualizar='tabelaImpostos.acoes.btAtualizar'
          :cpntFraseTop='tabelaImpostos.fraseTop'
          :cpntColuna='tabelaImpostos.coluna'
          :cpntLinha='tabelaImpostos.linha'
          :cpntCountAll='tabelaImpostos.countAll'
          :cpntColspan='tabelaImpostos.colspan'
          :cpntButtonsAcoes='tabelaImpostos.acoes.buttons'
          :cpntMper='tabelaImpostos.mper'
          :cpntPagina='tabelaImpostos.pagina'
          :cpntCheckboxEditar='tabelaImpostos.checkboxEditar'

          :ref='tabelaImpostos.id'
        ></RF-Tabela>
        
        <div :style="Object.keys(tabelaImpostos).length >= 1 && tabelaImpostos.mostrar === false ? 'margin: -15px 0px 30px 0px;' : 'margin: 20px 0px 30px 0px;'">              
          Estimativa de Impostos (Campo informações adicionais da NFS-e) 
        </div>
        <RF-Formulario :data-time='time'
          :cpntTime='time'
          :cpntId='formulario2.id' 
          :cpntStatus='""'
          :cpntField='formulario2.field'
          :cpntButtons='formulario1.buttons'
          :cpntUltAlt='formulario2.ult_alt'

          @onLimpaFormularioFocus='formulario2.focus = ""'
          :ref='formulario2.id'
        ></RF-Formulario>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
</style>

<style>
  .servico-sit-fiscal-codigoRF > div > .rf-bt-copiar {
    vertical-align: -15px;
  }
</style>

<script>
  export default {
    components: {
      'RF-Codigo-RF': () => import('@/components/rf-geral/codigo-rf/RF-Codigo-RF.vue')
    },
    props: {
      cpntId: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntNomeDig: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntAbrirEstado: {
        required: false,
        type: String,
        default: function () {
          return this.$store.state.licenca.uf
        }
      },
      cpntOnFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: new Date().getTime(),
        registro: [],
        statusGeral: '',
        formulario1: {},
        formulario2: {},
        tabelaImpostos: {},
        optionsImposto: [ { id: 'pis', nome: 'PIS' }, { id: 'cofins', nome: 'COFINS' }, { id: 'csll', nome: 'CSLL' }, { id: 'irrf', nome: 'IRRF' }, { id: 'inss', nome: 'INSS' } ]
      }
    },
    mounted: function () {
      // Pacote => 15 = Serviços | 25 = NFS-e
      // Módulo => 48 = NFSe
      // Permissão => 531 = Situações Fiscais
      if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 25, 15 ], 'and', [ 48 ], null, [ 531 ], null, true) === true) {
        this.iniciarVerificacao()
      }
    },
    methods: {
      iniciarVerificacao: function () {
        var self = this

        // SETA O STATUS GERAL
        self.statusGeral = 'carregando'

        // RESETA OS REGISTROS DA TELA
        self.registro = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        var mensagem = ''
        if (self.$store.state.licenca.cnae.aRamIds.length === 0 && self.$store.state.licenca.atividade.aAtiIds.length === 0) {
          mensagem = 'Atenção <b>CNAE</b> e <b>Atividade</b> não cadastrada para sua empresa.'
        } else if (self.$store.state.licenca.cnae.aRamIds.length === 0) {
          mensagem = 'Atenção <b>CNAE</b> não cadastrados para sua empresa.'
        } else if (self.$store.state.licenca.atividade.aAtiIds.length === 0) {
          mensagem = 'Atenção <b>Atividade</b> não cadastrados para sua empresa.<br/>'
        }

        if (mensagem !== '') {
          if (self.$store.state.token.clu_mu === 'a') {
            mensagem += '<br/><br/><a href=\'' + process.env.VUE_APP_URL_WEB + '/' + self.$store.state.token.cts + '/config/cadastro\'>Clique aqui</a> para atualizar o cadastro da sua empresa'
          } else {
            mensagem += '<br/><br/>Informe o Administrador da Licença de Uso para inserir estas informações no Meu Cadastro.'
          }

          self.statusGeral = { loc: 'WEB', cod: '999', err: mensagem }
        } else {
          // FAZ A VERIFICAÇÃO DO REGISTRO QUE ESTA SENDO TRABALHADO
          self.$store.state.CHECK_REGISTRO_FORM(self.cpntId, self.$route.params.id, function (reg, status) {
            // VERIFICA SE DEU ALGUM ERRO
            if (status === '') {
              // SETA OS REGISTROS RECEBIDOS
              self.registro = reg

              // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
              self.iniciaFormulario()
            }
          })
        }
      },
      iniciaFormulario: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario1 = {
          status: 'carregando',
          id: 'form-servico-sit-fiscal',
          focus: '',
          field: {}
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CONTA O NUMERO DE SEPARADORES
        var contField = 0

        self.formulario1.field = {
          categoria: {
            tipo: 'select2-chosen',
            tamanho: 2,
            nome: 'Categoria',
            multiple: true,
            apiEnv: 'j_id_ser_cat',
            // apiRec: 'j_id_ser_cat',
            keyMostra: [ 'nome' ],
            keyValue: 'id',
            value: '',
            onChange: function (value, id) {
              self.onChangeValue('formulario1', id, value)
            }
          },
          copiar: {
            tipo: 'select2',
            tamanho: 2,
            nome: 'Copiar Configuração de',
            // multiple: true,
            // apiEnv: 'j_id_ser_cat',
            // apiRec: 'j_id_ser_cat',
            keyMostra: [ 'nome' ],
            keyValue: 'id',
            value: '',
            onChange: function (value, id) {
              self.onChangeValue('formulario1', id, value)
            }
          },
          nat_ope: {
            tipo: 'select2',
            tamanho: 1,
            nome: 'Natureza da Operação',
            apiEnv: 'nat_ope',
            apiRec: 'nat_ope',
            keyMostra: [ 'id', ' - ', 'nome' ],
            keyValue: 'id',
            value: '',
            onChange: function (value, id) {
              self.onChangeValue('formulario1', id, value)
            }
          },
          ramo_id: {
            tipo: 'select2',
            tamanho: 1,
            nome: 'Ramo de Atividade',
            apiEnv: 'ramo_id',
            apiRec: 'ramo_id',
            keyMostra: [ 'cnae', ' - ', 'nome' ],
            keyValue: 'cnae',
            value: '',
            onChange: function (value, id) {
              self.onChangeValue('formulario1', id, value)
            }
          },
          ati_id: {
            tipo: 'select2',
            tamanho: 1,
            nome: 'Atividade',
            apiEnv: 'ati_id',
            apiRec: 'ati_id',
            keyMostra: [ 'id', ' - ', 'nome' ],
            keyValue: 'id',
            value: '',
            onChange: function (value, id) {
              self.onChangeValue('formulario1', id, value)
            }
          },
          desc_pdr: {
            tipo: 'textarea',
            tamanho: 1,
            nome: 'Descrição',
            apiEnv: 'desc_pdr',
            apiRec: 'desc_pdr',
            value: 'Prestação dos serviço(s) #venda.nfse.cat.servicos# com vencimento em #venda.vcto.dia#/#venda.vcto.mes.l3#/#venda.vcto.ano# referente a venda #venda.codigo#.',
            onChange: function (value, id) {
              self.onChangeValue('formulario1', id, value)
            }
          },
          cod_tri: {
            tipo: 'input',
            tamanho: 3,
            nome: 'Código Tributação',
            apiEnv: 'cod_tri',
            apiRec: 'cod_tri',
            explica: { mensagem: 'O Código de tributação Municipal está relacionado com o Item da Lista de serviços, que é a classificação federal para os serviços tributáveis.<br/><br/>Como um item da lista pode estar relacionado a várias regras tributárias, as prefeituras criaram o código de tributação municipal para manter um controle granular e específico.<br/><br/>Dessa forma, essa informação varia de acordo com a empresa e o município, e deve ser adquirida junto ao órgão responsável no município.' },
            onChange: function (value, id) {
              self.onChangeValue('formulario1', id, value)
            }
          },
          'separador-0': { tipo: 'clear' },
          iss_a: {
            tipo: 'input',
            tamanho: 3,
            nome: 'Alíquota ISS de',
            apiEnv: 'iss_a',
            apiRec: 'iss_a',
            value: '0,00',
            mask: 'valorDecimal',
            onChange: function (value, id) {
              self.onChangeValue('formulario1', id, value)
            }
          }
        }
        self.formulario1.field['separador-' + contField] = { tipo: 'clear' }
        contField++

        // CRIA A TABELA COM OS DADOS DOS IMPOSTOS
        self.tabelaImpostos = {
          mostrar: true,
          status: 'carregando',
          id: 'form-sit-fiscal',
          colqtip: {},
          colspan: {},
          api: {
            router: '',
            field: '',
            order: {},
            where: {},
            model: ''
          },
          mper: {
            field: false,
            rpp: false,
            order: false
          },
          countAll: 0,
          acoes: {
            buttons: [],
            fields: {},
            btImprimir: false,
            btAtualizar: false
          },
          pagina: {},
          checkboxEditar: 'id',

          coluna: [
            { mPer: 3, chave: 'nome', nome: 'Imposto' },
            { mPer: 3, chave: 'al', nome: 'Alíquota (%)' },
            { mPer: 3, chave: 'ag', nome: 'Agrupado com' },
            { mPer: 3, chave: 'vm', nome: 'Valor mínimo do<br/>Documento de Arrecadação<br/>(R$): Ex: DARF, GPS, etc.' }
          ],
          linha: [
            {
              nome: 'PIS',
              id: 'pis',
              al: [
                {
                  tamanho: 56,
                  tipo: 'input',
                  value: '0,00',
                  mask: 'valorDecimal',
                  apiRec: 'r_pis_a',
                  apiEnv: 'r_pis_a',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ],
              ag: [
                {
                  tamanho: 56,
                  tipo: 'select2',
                  value: '',
                  options: [],
                  keyMostra: [ 'nome' ],
                  keyValue: 'id',
                  optionInicialNome: '-',
                  optionInicialValue: '',
                  apiRec: 'r_pis_vm',
                  apiEnv: 'r_pis_vm',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ],
              vm: [
                {
                  tamanho: 56,
                  tipo: 'input',
                  value: '0,00',
                  mask: 'valor',
                  apiRec: 'r_pis_vm',
                  apiEnv: 'r_pis_vm',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ]
            },
            {
              nome: 'COFINS',
              id: 'cofins',
              al: [
                {
                  tamanho: 56,
                  tipo: 'input',
                  value: '0,00',
                  mask: 'valorDecimal',
                  apiRec: 'r_cofins_a',
                  apiEnv: 'r_cofins_a',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ],
              ag: [
                {
                  tamanho: 56,
                  tipo: 'select2',
                  value: '',
                  options: [],
                  keyMostra: [ 'nome' ],
                  keyValue: 'id',
                  optionInicialNome: '-',
                  optionInicialValue: '',
                  apiRec: 'r_cofins_vm',
                  apiEnv: 'r_cofins_vm',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ],
              vm: [
                {
                  tamanho: 56,
                  tipo: 'input',
                  value: '0,00',
                  mask: 'valor',
                  apiRec: 'r_cofins_vm',
                  apiEnv: 'r_cofins_vm',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ]
            },
            {
              nome: 'CSLL',
              id: 'csll',
              al: [
                {
                  tamanho: 56,
                  tipo: 'input',
                  value: '0,00',
                  mask: 'valorDecimal',
                  apiRec: 'r_csll_a',
                  apiEnv: 'r_csll_a',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ],
              ag: [
                {
                  tamanho: 56,
                  tipo: 'select2',
                  value: '',
                  options: [],
                  keyMostra: [ 'nome' ],
                  keyValue: 'id',
                  optionInicialNome: '-',
                  optionInicialValue: '',
                  apiRec: 'r_csll_vm',
                  apiEnv: 'r_csll_vm',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ],
              vm: [
                {
                  tamanho: 56,
                  tipo: 'input',
                  value: '0,00',
                  mask: 'valor',
                  apiRec: 'r_csll_vm',
                  apiEnv: 'r_csll_vm',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ]
            },
            {
              nome: 'IRRF',
              id: 'irrf',
              al: [
                {
                  tamanho: 56,
                  tipo: 'input',
                  value: '0,00',
                  mask: 'valorDecimal',
                  apiRec: 'r_irrf_a',
                  apiEnv: 'r_irrf_a',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ],
              ag: [
                {
                  tamanho: 56,
                  tipo: 'select2',
                  value: '',
                  options: [],
                  keyMostra: [ 'nome' ],
                  keyValue: 'id',
                  optionInicialNome: '-',
                  optionInicialValue: '',
                  apiRec: 'r_irrf_vm',
                  apiEnv: 'r_irrf_vm',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ],
              vm: [
                {
                  tamanho: 56,
                  tipo: 'input',
                  value: '0,00',
                  mask: 'valor',
                  apiRec: 'r_irrf_vm',
                  apiEnv: 'r_irrf_vm',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ]
            },
            {
              nome: 'INSS',
              id: 'inss',
              al: [
                {
                  tamanho: 56,
                  tipo: 'input',
                  value: '0,00',
                  mask: 'valorDecimal',
                  apiRec: 'r_inss_a',
                  apiEnv: 'r_inss_a',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ],
              ag: [
                {
                  tamanho: 56,
                  tipo: 'select2',
                  value: '',
                  options: [],
                  keyMostra: [ 'nome' ],
                  keyValue: 'id',
                  optionInicialNome: '-',
                  optionInicialValue: '',
                  apiRec: 'r_inss_vm',
                  apiEnv: 'r_inss_vm',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ],
              vm: [
                {
                  tamanho: 56,
                  tipo: 'input',
                  value: '0,00',
                  mask: 'valor',
                  apiRec: 'r_inss_vm',
                  apiEnv: 'r_inss_vm',
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ]
            }
          ]
        }

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario2 = {
          status: 'carregando',
          id: 'form-servico-sit-fiscal',
          focus: '',
          field: {}
        }

        self.formulario2.field = {
          p_fed: {
            tipo: 'input',
            tamanho: 3,
            nome: '% Federal',
            apiEnv: 'p_fed',
            apiRec: 'p_fed',
            value: '0,00',
            mask: 'valor',
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          },
          p_est: {
            tipo: 'input',
            tamanho: 3,
            nome: '% Estadual',
            apiEnv: 'p_est',
            apiRec: 'p_est',
            value: '0,00',
            mask: 'valor',
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          },
          p_mun: {
            tipo: 'input',
            tamanho: 3,
            nome: '% Municipal',
            apiEnv: 'p_mun',
            apiRec: 'p_mun',
            value: '0,00',
            mask: 'valor',
            onChange: function (value, id) {
              self.onChangeValue('formulario2', id, value)
            }
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        self.$store.state.FUN_CREATE_KEY_FIELDS_TABELA(self.tabelaImpostos.id, self.tabelaImpostos.linha, function (linha) {
          // SETA OS DADOS DOS CAMPOS RECEBIDOS
          self.tabelaImpostos.linha = linha

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
          self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario1.field, function (fields) {
            // SETA OS CAMPOS RECEBIDOS
            self.formulario1.field = fields

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
            self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario2.field, function (fields) {
              // SETA OS CAMPOS RECEBIDOS
              self.formulario2.field = fields

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null }, order: { id: 'asc' } }

              // COMUNICA COM A API
              self.$store.state.comunicaAPI('/referencia/ser-nat-operacao/get/', 'GET', queryGet, function (apiSuccess) {
                // SETA OS VALORES RECEBIDOS
                self.formulario1.field.nat_ope.options = apiSuccess.data

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()

                queryGet = { type: 'list', field: { cnae: null, nome: null }, limit: { row: 0, qty: 1000 }, where: { f: 'cnae', o: 'in', v: self.$store.state.licenca.cnae.aRamIds.join() } }

                // COMUNICA COM A API
                self.$store.state.comunicaAPI('/referencia/cnae/get/', 'GET', queryGet, function (apiSuccess) {
                  // SETA OS VALORES RECEBIDOS
                  self.formulario1.field.ramo_id.options = apiSuccess.data

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  self.time = new Date().getTime()

                  queryGet = { type: 'list', field: { id: null, nome: null }, limit: { row: 0, qty: 1000 }, where: { f: 'id', o: 'in', v: self.$store.state.licenca.atividade.aAtiIds.join() } }

                  // COMUNICA COM A API
                  self.$store.state.comunicaAPI('/referencia/ser-atividade/get/', 'GET', queryGet, function (apiSuccess) {
                    // SETA OS VALORES RECEBIDOS
                    self.formulario1.field.ati_id.options = apiSuccess.data

                    // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                    self.time = new Date().getTime()

                    // CHAMA A FUNÇÃO PARA BUSCAR OS DADOS NA API
                    self.buscarRegistro()
                  }, function (apiError) {
                    // SETA O STATUS
                    self.statusGeral = apiError

                    // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                    self.time = new Date().getTime()
                  })
                }, function (apiError) {
                  // SETA O STATUS
                  self.statusGeral = apiError

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  self.time = new Date().getTime()
                })
              }, function (apiError) {
                // SETA O STATUS
                self.statusGeral = apiError

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              })
            })
          })
        })
      },
      buscarRegistro: function () {
        var self = this

        // SETA O QUERY GET NA API
        var queryGet = { type: 'list', field: { id_ser_cat: null }, return: 'arrayGroupByField' }

        // COMUNICA COM A API
        self.$store.state.comunicaAPI('/servico/cat-sit-fiscal/get/', 'GET', queryGet, function (apiSuccess) {
          var categoriaExiste = apiSuccess.data.id_ser_cat.split(',')

          // REALIZA GET DA CATEGORIA
          queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null }, order: { nome: 'asc' }, where: { aOr: [ { f: 'status', o: '=', v: 1 }, { f: 'id', o: 'in', v: self.registro.join() } ] } }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          self.$store.state.comunicaAPI('/servico/categoria/get/', 'GET', queryGet, function (apiSuccess) {
            self.formulario1.field.categoria.options = []
            self.formulario1.field.copiar.options = []

            for (var key in apiSuccess.data) {
              if (categoriaExiste.length >= 1 && categoriaExiste.filter(item => (item.toString() === apiSuccess.data[key].id.toString() && self.registro.indexOf(Number(item)) === -1)).length >= 1) {
                self.formulario1.field.copiar.options.push(apiSuccess.data[key])
              } else {
                self.formulario1.field.categoria.options.push(apiSuccess.data[key])
              }
            }

            if (self.registro.filter(item => item <= 0).length === 0) {
              // SETA O QUERY GET NA API
              var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { f: 'id_ser_cat', o: 'in', v: self.registro.join() }, field: { id_ser_cat: null, nat_ope: null, ramo_id: null, ati_id: null, desc_pdr: null, cod_tri: null, iss_a: null, r_pis_a: null, r_pis_vm: null, r_cofins_a: null, r_cofins_vm: null, r_csll_a: null, r_csll_vm: null, r_irrf_a: null, r_irrf_vm: null, r_inss_a: null, r_inss_vm: null, p_fed: null, p_est: null, p_mun: null, created_at: null, created_user: null, last_at: null, last_user: { j: { usuario: null } } } }

              self.$store.state.comunicaAPI('/servico/cat-sit-fiscal/get/', 'GET', queryGet, function (apiSuccess) {
                if (apiSuccess.data.length >= 1) {
                  self.setarValorFormulario(apiSuccess.data[0])
                } else {
                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  self.time = new Date().getTime()

                  // CHAMA A FUNÇÃO PARA ORGANIZAR OS IMPOSTOS E PASSA A FUNÇÃO DE CALLBACK
                  self.organizaOptionsImposto(self.finalizaFormulario)
                }
              }, function (apiError) {
                // SETA O STATUS PARA O FORMULARIO
                self.statusGeral = apiError

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              })
            } else {
              // CHAMA A FUNÇÃO PARA ORGANIZAR OS IMPOSTOS E PASSA A FUNÇÃO DE CALLBACK
              self.organizaOptionsImposto(self.finalizaFormulario)
            }
          }, function (apiError) {
            // SETA O STATUS
            self.statusGeral = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        }, function (apiError) {
          // SETA O STATUS
          self.statusGeral = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      setarValorFormulario: function (registro, valueIni = true) {
        var self = this

        // // var removeDuasCasas = [ 'p_fed', 'p_mun', 'p_est', 'iss_a' ]
        // var removeDuasCasas = [ 'iss_a', 'r_pis_a', 'r_cofins_a', 'r_csll_a', 'r_irrf_a', 'r_inss_a' ]
        // for (var key in removeDuasCasas) {
        //   if (isNaN(registro[removeDuasCasas[key]]) === false) {
        //     registro[removeDuasCasas[key]] = registro[removeDuasCasas[key]].substring(0, (registro[removeDuasCasas[key]].length - 2)).replace('.', ',')
        //   }
        // }

        self.$store.state.FUN_API_RET_SET_VALUE(self.formulario1, registro, function (form) {
          // SETA OS CAMPOS RECEBIDOS
          self.formulario1 = form

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          self.$store.state.FUN_API_RET_SET_VALUE(self.formulario2, registro, function (form) {
            // SETA OS CAMPOS RECEBIDOS
            self.formulario2 = form

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            self.$store.state.FUN_API_RET_SET_VALUE_TABELA(self.tabelaImpostos.linha, registro, function (linhas) {
              // SETA AS LINHAS RECEBIDOS
              self.tabelaImpostos.linha = linhas

              for (var keyL in self.tabelaImpostos.linha) {
                if (self.optionsImposto.filter(item => item.id === self.tabelaImpostos.linha[keyL]['ag'][0].value).length === 0) {
                  self.tabelaImpostos.linha[keyL]['ag'][0].value = ''
                  self.tabelaImpostos.linha[keyL]['ag'][0].valueIni = ''

                  self.tabelaImpostos.linha[keyL]['vm'][0].disabled = false
                } else {
                  self.tabelaImpostos.linha[keyL]['vm'][0].value = 'agrupado'
                  self.tabelaImpostos.linha[keyL]['vm'][0].valueIni = 'agrupado'
                  self.tabelaImpostos.linha[keyL]['vm'][0].disabled = true
                }
              }

              if (valueIni === false) {
                for (var key1 in self.tabelaImpostos.linha) {
                  for (var key2 in self.tabelaImpostos.linha[key1]) {
                    if ([ 'id', 'nome' ].filter(item => item === key2).length === 0) {
                      for (var key3 in self.tabelaImpostos.linha[key1][key2]) {
                        if (self.tabelaImpostos.linha[key1][key2][key3].hasOwnProperty('valueIni')) {
                          self.tabelaImpostos.linha[key1][key2][key3].valueIni = ''
                        }
                      }
                    }
                  }
                }

                for (key1 in self.formulario1.field) {
                  if (self.formulario1.field[key1].hasOwnProperty('valueIni')) {
                    self.formulario1.field[key1].valueIni = ''
                  }
                }

                for (key1 in self.formulario2.field) {
                  if (self.formulario2.field[key1].hasOwnProperty('valueIni')) {
                    self.formulario2.field[key1].valueIni = ''
                  }
                }
              }

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA ORGANIZAR OS IMPOSTOS E PASSA A FUNÇÃO DE CALLBACK
              self.organizaOptionsImposto(self.finalizaFormulario)
            })
          }, [ 'last_at_ptbr', 'last_user', 'last_user_usuario' ])
        }, [])
      },
      organizaOptionsImposto: function (callback = null) {
        var self = this

        var optionRemove = []

        for (var key1 in self.tabelaImpostos.linha) {
          // SETA TODOS OS OPTIONS EXISTENTE
          self.tabelaImpostos.linha[key1]['ag'][0].options = self.optionsImposto.filter(item => item.id !== self.tabelaImpostos.linha[key1].id)

          if (self.tabelaImpostos.linha[key1]['ag'][0].value !== '') {
            optionRemove.push(self.optionsImposto.filter(item => item.id === self.tabelaImpostos.linha[key1].id)[0].id)

            for (var key3 in self.tabelaImpostos.linha) {
              if (key1 !== key3 && self.tabelaImpostos.linha[key1].id === self.tabelaImpostos.linha[key3]['ag'][0].value) {
                self.tabelaImpostos.linha[key3]['ag'][0].value = ''

                optionRemove = optionRemove.filter(item => item !== self.tabelaImpostos.linha[key3].id)
              }
            }
          }
        }

        for (var key2 in self.tabelaImpostos.linha) {
          // VERIFICA SE TEM ALGUM VALOR PARA SER REMOVIDO
          if (optionRemove.length >= 1) {
            self.tabelaImpostos.linha[key2]['ag'][0].options = self.tabelaImpostos.linha[key2]['ag'][0].options.filter(item => (optionRemove.indexOf(item.id) === -1 || (self.tabelaImpostos.linha[key2]['ag'][0].value !== '' && optionRemove.indexOf(self.tabelaImpostos.linha[key2]['ag'][0].value) !== -1)))
          }

          // VERIFICA COMO DEVE SER APRESENTADO CADA CAMPO
          if (self.tabelaImpostos.linha[key2]['ag'][0].value !== '') {
            self.tabelaImpostos.linha[key2]['vm'][0].value = ''
            self.tabelaImpostos.linha[key2]['vm'][0].disabled = true
            self.tabelaImpostos.linha[key2]['vm'][0].placeholder = 'agrupado'
            self.tabelaImpostos.linha[key2]['vm'][0].mask = null
          } else if (self.tabelaImpostos.linha[key2]['vm'][0].placeholder === 'agrupado') {
            self.tabelaImpostos.linha[key2]['vm'][0].value = '0,00'
            self.tabelaImpostos.linha[key2]['vm'][0].disabled = false
            self.tabelaImpostos.linha[key2]['vm'][0].placeholder = ''
            self.tabelaImpostos.linha[key2]['vm'][0].mask = 'valor'
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        if (callback !== null) {
          callback()
        }
      },
      onChangeValue: function (form, id, value) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.substring((this[form].id.length + 1), id.length)

        // SETA O VALOR RECEBIDO
        this[form].field[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this[form].field[index].mensagem = ''
        this[form].field[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        switch (index) {
          case 'copiar':
            var self = this

            if (self[form].field[index].value !== '') {
              // SETA O QUERY GET NA API
              var queryGet = { type: 'list', limit: { row: 0, qty: 1 }, where: { f: 'id_ser_cat', o: '=', v: self[form].field[index].value } }
              // var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { f: 'id_ser_cat', o: 'in', v: self.registro.join() }, field: { id_ser_cat: null, nat_ope: null, ramo_id: null, ati_id: null, desc_pdr: null, iss_a: null, r_pis_a: null, r_pis_vm: null, r_cofins_a: null, r_cofins_vm: null, r_csll_a: null, r_csll_vm: null, r_irrf_a: null, r_irrf_vm: null, r_inss_a: null, r_inss_vm: null, p_fed: null, p_est: null, p_mun: null, created_at: null, created_user: null, last_at: null, last_user: { j: { usuario: null } } } }

              // COMUNICA COM A API
              self.$store.state.comunicaAPI('/servico/cat-sit-fiscal/get/', 'GET', queryGet, function (apiSuccess) {
                // LIMPA O VALOR SELECIONADO
                self[form].field[index].value = ''

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()

                // SETA OS NOVOS VALORES
                self.setarValorFormulario(apiSuccess.data[0], false)
              }, function (apiError) {
                // SETA O STATUS
                self.formulario.status = apiError

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              })
            }
            break
        }
      },
      onChangeValueTabela: function (id, value) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')

        // SETA O VALOR RECEBIDO
        this.tabelaImpostos.linha[index[1]][index[2]][index[3]].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.tabelaImpostos.linha[index[1]][index[2]][index[3]].mensagem = ''
        this.tabelaImpostos.linha[index[1]][index[2]][index[3]].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        switch (index[2]) {
          case 'ag':
            this.organizaOptionsImposto()
            break
        }
      },
      finalizaFormulario: function () {
        var self = this

        // SE A EMPRESA FOR DO SIMPLES NACIONAL OS CAMPOS DEVE SER INFORMADOS COMO ZERO
        if ([ '1', '3', '7', '8' ].filter(item => item === self.$store.state.licenca.OptanteSimples).length >= 1) {
          // NÃO MOSTRA A TABELA
          self.tabelaImpostos.mostrar = false

          for (var key2 in self.tabelaImpostos.linha) {
            if (self.tabelaImpostos.linha[key2].al[0].hasOwnProperty('apiEnv')) {
              self.tabelaImpostos.linha[key2].al[0].value = '0,00'
              self.tabelaImpostos.linha[key2].al[0].disabled = true

              self.tabelaImpostos.linha[key2].ag[0].value = ''
              self.tabelaImpostos.linha[key2].ag[0].disabled = true

              self.tabelaImpostos.linha[key2].vm[0].value = '0,00'
              self.tabelaImpostos.linha[key2].vm[0].disabled = true
              self.tabelaImpostos.linha[key2].vm[0].placeholder = ''
            }
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        self.$store.state.FUN_CREATE_BUTTON_FORM(self.formulario1.id, self.registro, self.cpntId, {
          env: function () {
            self.onEnviarForm('env')
          },
          can: function () {
            self.onFecharFormulario(false)
          }
        }, function (buttons) {
          // CRIA OS BUTTONS DO FORMULARIO
          self.formulario1.buttons = buttons

          // DESATIVA O CAMPO CATEGORIA SE ESTIVER EDITANDO ALGUM REGISTRO
          if ((self.registro.length >= 1 && self.registro[0] !== 0)) {
            self.formulario1.field.categoria.disabled = true
            self.formulario1.field.categoria.value = self.registro
          }

          // SETA O CAMPO PARA O CODIGO RF
          self.formulario1.codigoRF = {
            id: self.formulario1.id + '-codigoRF',
            tamanho: 1,
            status: '',
            router: '/servico/cat-sit-fiscal/crf'
          }

          // SETA O STATUS PARA O FORMULARIO
          self.statusGeral = ''

          // REMOVE O STATUS DA TABELA
          self.tabelaImpostos.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          setTimeout(function () {
            // SETA O FOCUS NO CAMPO
            self.formulario1.focus = 'nome'

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }, 300)
        })
      },
      onFecharFormulario: function (atualizar = false, id = null) {
        var self = this

        if (self.cpntId !== null) {
          self.cpntOnFecharFormulario(atualizar, id)
        } else {
          if (self.cpntOnFecharFormulario !== null) {
            // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
            self.cpntOnFecharFormulario(atualizar, id)
          }

          // setTimeout(function () {
          //   // ALTERA A ROTA
          self.$router.push({ name: 'serv_sit_fisc' })
          // }, 300)
        }
      },
      onEnviarForm: function (but) {
        var self = this

        // SETA O STATUS DO BUTTON
        self.formulario1.buttons[but].status = 'carregando'

        var valor = ''

        self.$store.state.FUN_CREATE_FORM_API_FORMULARIO(self.formulario1.field, {}, function (formData1) {
          self.$store.state.FUN_CREATE_FORM_API_FORMULARIO(self.formulario2.field, {}, function (formData2) {
            // AGRUPA OS VETORES
            var formData = Object.assign(formData1, formData2)

            for (var keyL in self.tabelaImpostos.linha) {
              if (typeof (self.tabelaImpostos.linha[keyL]) === 'object') {
                if (self.tabelaImpostos.linha[keyL]['al'][0].value !== self.tabelaImpostos.linha[keyL]['al'][0].valueIni) {
                  formData[self.tabelaImpostos.linha[keyL]['al'][0].apiEnv] = self.tabelaImpostos.linha[keyL]['al'][0].value

                  // REMOVE OS PONTOS DA STRING
                  while ((formData[self.tabelaImpostos.linha[keyL]['al'][0].apiEnv].indexOf('.') > -1)) {
                    formData[self.tabelaImpostos.linha[keyL]['al'][0].apiEnv] = formData[self.tabelaImpostos.linha[keyL]['al'][0].apiEnv].replace('.', '')
                  }
                  formData[self.tabelaImpostos.linha[keyL]['al'][0].apiEnv] = formData[self.tabelaImpostos.linha[keyL]['al'][0].apiEnv].replace(',', '.')
                }

                if (self.tabelaImpostos.linha[keyL]['ag'][0].value !== '') {
                  formData[self.tabelaImpostos.linha[keyL]['ag'][0].apiEnv] = self.tabelaImpostos.linha[keyL]['ag'][0].value
                } else if (self.tabelaImpostos.linha[keyL]['ag'][0].value === '') {
                  valor = self.tabelaImpostos.linha[keyL]['vm'][0].value.toString()

                  // REMOVE OS PONTOS DA STRING
                  while ((valor.indexOf('.') > -1) || (valor.indexOf(',') > -1)) {
                    valor = valor.replace('.', '')
                    valor = valor.replace(',', '')
                  }

                  // VERIFICA SE DEVE INFORMAR ZERO EM VEZ DE 000
                  if (valor === '000') {
                    valor = '0'
                  }

                  // SETA O NOVO VALOR
                  formData[self.tabelaImpostos.linha[keyL]['vm'][0].apiEnv] = valor
                }
              }
            }
            // // 'p_fed', 'p_est', 'p_mun'
            // var adicionaDuasCasas = [ 'iss_a', 'r_pis_a', 'r_cofins_a', 'r_csll_a', 'r_irrf_a', 'r_inss_a' ]
            // for (var key in adicionaDuasCasas) {
            //   if (formData.hasOwnProperty(adicionaDuasCasas[key])) {
            //     valor = formData[adicionaDuasCasas[key]].match(/[0-9]+/g).join('').toString()

            //     formData[adicionaDuasCasas[key]] = valor.substring(0, (valor.length - 2)) + '.' + valor.substring((valor.length - 2), valor.length) + '00'
            //   }
            // }

            var converte = [ 'p_fed', 'p_est', 'p_mun' ]
            for (var key2 in converte) {
              if (formData.hasOwnProperty(converte[key2])) {
                formData[converte[key2]] = (formData[converte[key2]] / 100).toString()
              }
            }

            // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
            self.time = new Date().getTime()

            if (Object.keys(formData).length >= 1) {
              // SETA O ID DOS PRODUTOS
              if ((self.registro.length === 1 && self.registro[0] >= 1) || self.registro.length > 1) {
                formData.j_id_ser_cat = JSON.stringify(self.registro)
              } else {
                formData.j_id_ser_cat = JSON.stringify(self.formulario1.field.categoria.value)
              }

              self.$store.state.comunicaAPI('/servico/cat-sit-fiscal', 'PUT', formData, function (apiSuccess) {
                self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
                  if (but === 'insMais') {
                    self.iniciarVerificacao()
                  } else {
                    // SETA O STATUS DO BUTTON
                    self.formulario1.buttons.can.status = ''
                    self.formulario1.buttons.env.status = ''
                    // self.formulario1.buttons.insMais.status = ''

                    // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
                    self.formulario1.time = new Date().getTime()

                    // FECHA O FORMULARIO
                    self.onFecharFormulario(true)
                  }
                })
              }, function (apiError) {
                // SETA O STATUS PARA O FORMULARIO
                self.statusGeral = apiError

                // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
                self.time = new Date().getTime()
              }, function (apiValid, apiStatus) {
                self.$store.state.FUN_API_RET_VALIDA(self, 'formulario1', apiValid, apiStatus, self.formulario1.field, false, function (field, focus, apiValid) {
                  // SETA OS CAMPOS COM OS ERROS
                  self.formulario1.field = field

                  self.$store.state.FUN_API_RET_VALIDA(self, 'formulario2', apiValid, apiStatus, self.formulario2.field, false, function (field, focus, apiValid) {
                    // SETA OS CAMPOS COM OS ERROS
                    self.formulario2.field = field

                    self.$store.state.FUN_API_RET_VALIDA_TABELA(apiValid, apiStatus, self.tabelaImpostos.linha, true, function (linha) {
                      // SETA OS CAMPOS COM OS ERROS
                      self.tabelaImpostos.linha = linha

                      // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
                      self.formulario1.buttons.env.status = ''

                      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                      self.time = new Date().getTime()
                    })
                  })
                })
              })
            } else {
              self.$store.state.msgWarn('Nenhum campo foi atualizado.', 'warning')

              // SETA O STATUS DO BUTTON
              self.formulario1.buttons.can.status = ''
              self.formulario1.buttons.env.status = ''
              // self.formulario1.buttons.insMais.status = ''

              // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          })
        })
      }
    },
    watch: {
      '$route': function () {
        this.iniciarVerificacao()
      },
      'cpntId': function () {
        this.iniciarVerificacao()
      }
    }
  }
</script>
